//
import React from "react";
//component
import AudioUrlClone from "component/audio/action_url_clone";
//redux
//selector
import { draftDialogUrlSelector } from "store/bailiff/task/dialog/draft_dialog.selector";
//actions
//utils
//hook
import { useSelector } from "react-redux";
//str

const DetailSoundClone = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const url = useSelector(draftDialogUrlSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!url) return null;
  return <AudioUrlClone url={url} />;
};
export default DetailSoundClone;
